module.exports = __webpack_public_path__ + "static/media/guitars.f869d36f.svg";